<template>
    <main>
        <div class="modal fade" id="modalOrdenes" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Listado de Ordenes, Historia No: {{id_historia}}</h5>
                    <button type="button" class="close"  @click="cerrar();" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card mt-2 shadow-none"  v-if="isLoading">
                        <div class="card-body">
                          <content-placeholders :rounded="true">
                            <content-placeholders-heading :img="false" />
                            <content-placeholders-text :lines="3" />
                          </content-placeholders>
                        </div>
                    </div>
                    <div class="alert alert-warning mt-2" v-else-if="!ordenes.length">
                        No se han cargado ordenes...
                    </div>
                    <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in ordenes" :key="item.id">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="col-4 ">
                                    Orden No. {{item.id}} 
                                </div>
                                <div class="col-8 d-flex justify-content-end">
                                    <span class="text-danger mx-2">{{item.user.name}}</span> ({{item.created_at | formatDateTime}})
                                    <button @click="imprimir(item.id);" class="btn btn-outline-info lift mx-2 shadow-sm btn-sm" >
                                        <i class="fa fa-print fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" >
                            <div class="row">
                                <div class="col-md-8 col-sm-12 col-lg-12 font-weight-bold" v-for="procedimiento in item.items" :key="procedimiento.id">
                                    {{ procedimiento.servicio.codigo }}
                                    {{ procedimiento.servicio.descripcion }}
                                    <div class="small text-muted d-none d-md-block">
                                        Observación: {{ procedimiento.observacion }}
                                    </div>
                                    <hr>
                                </div>
                                <div class="col-md-8 col-sm-12 col-lg-12">
                                    Observaciones Generales: <span class="text-primary">{{item.observaciones}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" @click="cerrar();"><i class="far fa-times-circle fa-fw"></i> Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        
    </main>
</template>
<script>
import historiaClinicaService from '../../../../services/historiaClinicaService';
import ordenClinicaService from '../../../../services/ordenClinicaService';
import $ from "jquery";
export default {
    data(){
        return {
            id_historia:'',
            ordenes:{},
            isLoading:true,
        }
    },
    methods: {
        async  abrir(id,type){
            this.$nextTick(async () => {
                this.id_historia =id;
                $("#modalOrdenes").modal("show");
                this.isLoading = true;
                const response = await ordenClinicaService.showOrdenByHcAndType({
                    id_historia:id,
                    type:type
                });
                this.ordenes= response.data;
                this.isLoading= false;
            });
        },
        imprimir(id_orden){
            window.open(historiaClinicaService.orden(id_orden));
        },
        cerrar(){
            $("#modalOrdenes").modal("hide");
            this.ordenes= {};
        }
    },
}
</script>